import React from 'react';
import { MotorAd } from '../../types';
import { BaseSearchAdProps, SearchAdLayout } from '../search/SearchAdTypes';
import { gridClasses, listClasses } from '../legendary/LegendaryMotorSearchAd';
import { useSearchAdClasses } from '../search/SearchAdClasses';
import { SearchAd } from '../search/SearchAd';
import { MotorImage } from '../search/motor/MotorImage';
import { MotorHeading } from '../search/motor/MotorHeading';
import { MotorLabel } from '../search/motor/MotorLabel';
import { LegendaryAdImageOptions } from '../legendary/LegendaryAdImageOptions';

type MotorNativeAdvertisementProps = BaseSearchAdProps & {
    ad: Omit<
        MotorAd,
        | 'id'
        | 'price'
        | 'distance'
        | 'trade_type'
        | 'flags'
        | 'extras'
        | 'timestamp'
        | 'type'
    >;
    imageSizes?: string;
    layout: SearchAdLayout;
    contentBottom?: () => React.ReactElement | null;
    sponsorName?: () => React.ReactElement | null;
    label?: (props: { className: string }) => React.ReactElement | null;
};

export function MotorNativeAdvertisement(props: MotorNativeAdvertisementProps) {
    const {
        className = '',
        heading,
        image,
        imageSizes,
        label,
        layout,
        contentBottom,
        sponsorName,
        ...searchAdProps
    } = props;

    const layoutClasses = layout === 'grid' ? gridClasses : listClasses;
    const classes = useSearchAdClasses({
        mode: 'responsive',
        mobileClasses: layoutClasses.mobile,
        desktopClasses: layoutClasses.desktop,
    });

    const ad = props.ad as MotorAd;

    return (
        <SearchAd
            adId={ad.id}
            className={`${classes.ad} ${className}`}
            legendary
            {...searchAdProps}
        >
            <div className={classes.imageWrapper}>
                <LegendaryAdImageOptions>
                    <MotorImage
                        ad={ad}
                        image={image}
                        imageClass={classes.image}
                        sizes={imageSizes}
                    />
                </LegendaryAdImageOptions>
            </div>
            <div className={classes.content}>
                {sponsorName && (
                    <span className="text-s s-text-subtle">
                        {sponsorName()}
                    </span>
                )}
                <MotorHeading
                    ad={ad}
                    className={classes.heading}
                    heading={heading}
                />
                {contentBottom && contentBottom()}
            </div>
            <MotorLabel ad={ad} className={classes.ribbon} label={label} />
        </SearchAd>
    );
}
